define('baseline/lasers',["require", "exports", "../util/http"], function (require, exports, http_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.profile2csv = exports.deleteLaser = exports.setPublic = exports.save = exports.byUser = exports.getPublic = exports.byId = void 0;
    function byId(id) {
        return (0, http_1.getJson)("/lasers/" + id + ".json");
    }
    exports.byId = byId;
    // Fetch public laser profiles
    function getPublic() {
        return (0, http_1.getJson)("/lasers.json");
    }
    exports.getPublic = getPublic;
    // Fetch laser profiles by user
    function byUser(userId) {
        return (0, http_1.getJson)("/lasers.json?userid=" + userId);
    }
    exports.byUser = byUser;
    function save(laser) {
        return (0, http_1.postJson)("/lasers", laser);
    }
    exports.save = save;
    function setPublic(laserId, isPublic) {
        return (0, http_1.postJson)("/lasers/" + laserId + "/public", isPublic);
    }
    exports.setPublic = setPublic;
    function deleteLaser(laser) {
        return (0, http_1.deleteUrl)("/lasers/" + laser.laser_id);
    }
    exports.deleteLaser = deleteLaser;
    function profile2csv(profile) {
        return profile.points
            .map(function (p) { return p.x + ", " + p.y; })
            .join("\n");
    }
    exports.profile2csv = profile2csv;
});
//# sourceMappingURL=/assets/javascripts/baseline/lasers.js.map;
